export function formatDate(startDateStr, endDateStr) {
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);
  
  // Format start date
  const startDay = startDate.getDate();
  const startMonthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];
  const startMonthIndex = startDate.getMonth();
  const startYear = startDate.getFullYear();
  const formattedStartDate = `${startDay} ${startMonthNames[startMonthIndex]} ${startYear}`;

  // Format end date
  const endDay = endDate.getDate();
  const endMonthIndex = endDate.getMonth();
  const endYear = endDate.getFullYear();
  const formattedEndDate = `${endDay} ${startMonthNames[endMonthIndex]} ${endYear}`;

  return { formattedStartDate, formattedEndDate };
}
export const getDateRangeForMonth = (month) => {
  // Get current year
  const currentYear = new Date().getFullYear();

  // Convert month to 0-based index (January is 0, February is 1, etc.)
  const monthIndex = parseInt(month) - 1;

  // Calculate start date (first day of the month at 18:30:00.000Z)
  const startDate = new Date(Date.UTC(currentYear, monthIndex, 1, 18, 30, 0, 0));

  // Calculate end date (last day of the month at 18:29:59.999Z)
  const lastDayOfMonth = new Date(Date.UTC(currentYear, monthIndex + 1, 0)); // This gives the last day of the month
  const endDate = new Date(Date.UTC(currentYear, monthIndex, lastDayOfMonth.getUTCDate(), 18, 29, 59, 999));

  // Calculate new end date (last day of the next month)
  const newEndMonth = monthIndex + 2; // Next month after the specified month
  const newEndDate = new Date(Date.UTC(currentYear, newEndMonth, 0, 18, 29, 59, 999)); // Last day of the next month

  // Format dates to ISO string format
  const startISOString = startDate.toISOString();
  const endISOString = endDate.toISOString();
  const newEndISOString = newEndDate.toISOString();

  return { startDate: startISOString, endDate: endISOString, newEndDate: newEndISOString };
};

export function getMonthNames(monthNumber) {
  const currentDate = new Date(2000, monthNumber - 1, 1); 
  const selectedMonth = currentDate.toLocaleString('en-US', { month: 'long' });
  // Increment the month by 1 to get the next month
  currentDate.setMonth(currentDate.getMonth() + 1);
  // Get the full name of the next month
  const renewedTobeMonthe = currentDate.toLocaleString('en-US', { month: 'long' });
  return {selectedMonth, renewedTobeMonthe};
}